import React, { Component } from 'react';

import './style.scss';

export default class LatestNews extends Component {
    render() {
        return (
            <div className="latest-news">
                <iframe
                    title="latest-news"
                    allowtransparency="true"
                    marginHeight="0"
                    marginWidth="0"
                    className="responsive"
                    id="ExternalWebContentExternalIFrame"
                    src="https://otp.tools.investis.com/clients/uk/jdsports3/rns/regulatory-news-teaser.aspx?culture=en-GB"
                    frameBorder="0"
                    height="255"
                    width="100%"
                ></iframe>
            </div>
        );
    }
}
